import { createSelector } from '@reduxjs/toolkit';

const selectUserSettingsStore = (entities) => entities.userSettings;

export const selectUserSettings = createSelector(
  [selectUserSettingsStore],
  (userSettingsStore) => userSettingsStore.settings,
);
